"use client";
import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoButton, NeoSelect, NeoTextBox} from "@/components/forms";
import {useRoutePlan} from "@/context/routePlan/optimizer/routePlanVariant";
import {routePlanService} from "@/service/routePlan.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {parseTime} from "@internationalized/date";
import {SelectItem, Spinner, TimeInput, Tooltip} from "@nextui-org/react";
import Image from "next/image";
import {useEffect, useState} from "react";
import {Controller, useForm, useWatch} from "react-hook-form";
import {AiOutlineLoading} from "react-icons/ai";
import {FaRegClock} from "react-icons/fa";
import {IoMdInformationCircleOutline} from "react-icons/io";
import * as yup from "yup";
import FileUpload from "./fileUpload";
interface FormValues {
  id?: number | null;
  users: File | null;
  vehicles: File | null;
  maxTravelDistance: number | null;
  tripType: number | null;
  maxTravelTime: number | null;
  waitTime: number | null;
  // capacity: number | null;
  startTime: string;
  endTime: string;
}
const schema: yup.ObjectSchema<FormValues> = yup.object({
  id: yup.number().nullable(),
  users: yup
    .mixed<File>()
    .nullable() // allow null
    .required("Student file is required")
    .test(
      "fileSize",
      "File too large",
      value => !value || value.size <= 2_000_000
    ),
  vehicles: yup
    .mixed<File>()
    .nullable() // allow null
    .required("Vehicle file is required"),
  tripType: yup.number().required("Trip type is required"),
  maxTravelDistance: yup
    .number()
    .typeError("Must be a number")
    .required("Max KM is required")
    .min(5, "Minimum distance is 5 KM")
    .max(100, "Maximum distance is 100 KM"),
  maxTravelTime: yup
    .number()
    .typeError("Must be a number")
    .min(10, "Minimum travel time is 10 MIN")
    .max(240, "Maximum travel time is 240 MIN")
    .required("Max Time is required"),
  waitTime: yup
    .number()
    .typeError("Must be a number")
    .min(1, "Minimum wait time is 1 SEC")
    .max(300, "Maximum wait time is 5 MIN")
    .required("Wait Time is required"),
  // capacity: yup
  //   .number()
  //   .typeError("Must be a number")
  //   .min(3, "Minimum capacity is 3")
  //   .max(60, "Maximum capacity is 60")
  //   .required("Capacity is required"),
  startTime: yup.string().nullable().required("Start Time is required"),
  endTime: yup.string().required("End Time is required")
});
export const InputParammeter = function ({
  setIsHistoryTab
}: {
  setIsHistoryTab: (val: boolean) => void;
}) {
  const {planId, currentVariant, fetchRoutePlanData, setCurrentVariant} =
    useRoutePlan();
  const [loading, setLoading] = useState(false);
  const [creditLoading, setCreditLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [inputParamsErrorMessage, setinputParamsErrorMessage] = useState<
    string | null
  >(null);

  const [currentCreditPoint, setCurrentCreditPoint] = useState<number>(0);
  const [processingPopupmodal, setProcessingPopupmodal] = useState(false);
  const [processingErrorPopupmodal, setProcessingErrorPopupmodal] =
    useState(false);
  const [newAddedVariantId, setNewAddedVariantId] = useState<number | null>(0);
  const [userVehicleFileUrl, setUserVehicleFileUrl] = useState<{
    userData: string;
    vehicleData: string;
  }>({
    userData:
      "https://firebasestorage.googleapis.com/v0/b/api-project-361129609731.appspot.com/o/route_plan%2Fusers.csv?alt=media&token=91fe50fb-9663-4405-a810-804179fc266d",
    vehicleData:
      "https://firebasestorage.googleapis.com/v0/b/api-project-361129609731.appspot.com/o/route_plan%2Fvehicles.csv?alt=media&token=b84671d2-e28f-4539-bb90-99c71a4af3e7"
  });
  const {
    register,
    handleSubmit,
    control,
    setError,
    setValue,
    reset,
    formState: {errors, isSubmitting}
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      id: null,
      users: null,
      vehicles: null,
      maxTravelDistance: null,
      tripType: 0,
      maxTravelTime: null,
      waitTime: null,
      // capacity: null,
      startTime: "",
      endTime: ""
    }
  });

  const studentFile = useWatch({
    control,
    name: "users"
  });
  const formatTimeToHHMM = (timestamp?: number | null): string => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // Reset colors and checked routes when the current variant is changing

      await routePlanService
        .getRoutePlanOutput(currentVariant)
        .then((response: RoutePlanVariant | null) => {
          //console.log("Output Result", response);
          if (response?.input) {
            setUserVehicleFileUrl({
              userData: response.input.userData,
              vehicleData: response.input.vehicleData
            });
            setTimeout(() => {
              reset(
                {
                  id: currentVariant,
                  // userData: response.input.userData ?? null,
                  //vehicleData: response.input.vehicleData ?? null,
                  maxTravelDistance: response.input.maxDistance ?? null,
                  tripType: response.input.tripType ?? 0,
                  maxTravelTime: response.input.maxTime
                    ? Math.floor(response.input.maxTime / 60000)
                    : null,
                  waitTime: response.input.waitTime
                    ? Math.floor(response.input.waitTime / 60000)
                    : null,
                  //  capacity: response.input.capacity ?? null,
                  startTime: formatTimeToHHMM(response.input.startTime),
                  endTime: formatTimeToHHMM(response.input.endTime)
                },
                {keepDefaultValues: false}
              );
            }, 100);
            // setTimeout(() => {
            //   setValue("maxTravelDistance", response.input.maxDistance);
            //   setValue("tripType", response.input.tripType);
            //   setValue("maxTravelTime", response.input.maxTime);
            //   setValue("waitTime", response.input.waitTime);
            //   setValue("capacity", response.input.capacity);
            //   setValue("startTime", formatTimeToHHMM(response.input.startTime));
            //   setValue("endTime", formatTimeToHHMM(response.input.endTime));
            // }, 100);
            // reset(formattedData);
          }
          if (response?.status === 1) {
            // processed
            setNewAddedVariantId(currentVariant);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (currentVariant) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    setCurrentCreditPoint(0);
    if (studentFile) {
      const formData = new FormData();
      formData.append("studentFile", studentFile);
      formData.append("type", "1");

      setCreditLoading(true);
      // Example: API call to upload or process student file
      const uploadStudentFile = async () => {
        routePlanService
          .checkCredits(formData)
          .then(response => {
            if (response?.data?.status === "success") {
              //console.log(response.data?.data?.reportData?.creditsNeeded);
              //need to set credit data
              setCurrentCreditPoint(
                response.data?.data?.reportData?.creditsNeeded || 0
              );
            } else {
              setCurrentCreditPoint(0);
              const message = response.data?.message
                ?.replace(/\n/g, ", ")
                .replace(/,\s*$/, "");
              setErrorMessage(message || "An error occurred");
            }
          })
          .catch(err => {
            setCurrentCreditPoint(0);
            if (err?.errors?.length > 0) {
              err?.errors?.forEach(
                ({field, message}: {field: any; message: string}) => {
                  setError(field, {type: "server", message: message});
                }
              );
            }
          })
          .finally(() => {
            setCreditLoading(false);
            setTimeout(() => {
              setErrorMessage(null);
            }, 5000);
          });
      };

      uploadStudentFile();
    }
  }, [studentFile]);

  useEffect(() => {
    if (inputParamsErrorMessage) {
      setProcessingErrorPopupmodal(true);
    }
  }, [inputParamsErrorMessage]);
  useEffect(() => {
    if (newAddedVariantId && newAddedVariantId !== 0) {
      handlePopupModal();
    }
  }, [newAddedVariantId]);
  const handlePopupModal = () => {
    setProcessingPopupmodal(true);
  };
  function hhmmToMsToday(hhmm: string): number {
    // expect "08:30" or "8:30"
    const t = parseTime(hhmm); // throws on invalid
    const now = new Date();
    const d = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      t.hour,
      t.minute,
      t.second ?? 0,
      t.millisecond ?? 0
    );
    return d.getTime();
  }
  // console.log("Errors:", errors);
  const onSubmit = (data: FormValues) => {
    setinputParamsErrorMessage(null);
    setLoading(true);
    const formData = new FormData();

    if (data.users) formData.append("studentFile", data.users);
    if (data.vehicles) formData.append("vehicleFile", data.vehicles);
    const maxTimeInMilliSeconds = data.maxTravelTime
      ? data.maxTravelTime * 60 * 1000
      : 0; // convert minutes to milliseconds
    const waitTimeInMilliSeconds = data.waitTime
      ? data.waitTime * 60 * 1000
      : 0; // convert minutes to milliseconds
    const startTime = hhmmToMsToday(data.startTime);
    const endTime = hhmmToMsToday(data.endTime);
    formData.append(
      "maxDistance",
      data?.maxTravelDistance ? data.maxTravelDistance.toString() : ""
    );
    formData.append("maxTime", maxTimeInMilliSeconds.toString());
    formData.append("waitTime", waitTimeInMilliSeconds.toString());
    // if need will use below code instead of 0
    //data.capacity ? data.capacity.toString() : ""
    formData.append("maxCapacity", "0");
    formData.append("startTime", startTime.toString());
    formData.append("endTime", endTime.toString());
    formData.append("tripType", data.tripType ? data.tripType.toString() : "0");
    formData.append("planId", planId.toString());
    if (data.id) {
      formData.append("id", data.id.toString());
    }
    //  console.log(planId);
    //console.log("Form Data Entries:", data);

    routePlanService
      .addEditRoutePlanInputs(formData)
      .then(response => {
        if (response?.data?.status === "success") {
          // no need to move to history tab
          // setIsHistoryTab(true);
          //fetchRoutePlanData();
          //console.log(response?.data?.data.variantId);
          if (response?.data?.data?.variantId === currentVariant) {
            // console.log("opening popup");
            setNewAddedVariantId(currentVariant);
            setCurrentVariant(0);
            // handlePopupModal();
          } else {
            setNewAddedVariantId(response?.data?.data?.variantId);
          }
        } else {
          const message = response.data?.message
            ?.replace(/\n/g, ", ")
            .replace(/,\s*$/, "");
          setinputParamsErrorMessage(message || "An error occurred");
        }
      })
      .catch(err => {
        if (err?.errors?.length > 0) {
          err?.errors?.forEach(
            ({field, message}: {field: any; message: string}) => {
              setError(field, {type: "server", message: message});
            }
          );
        }
      })
      .finally(() => {
        setLoading(false);
        // setTimeout(() => {
        //   setErrorMessage(null);
        // }, 5000);
      });
  };

  const changeVariant = () => {
    //setIsHistoryTab(true);
    setCurrentVariant(newAddedVariantId);
    setNewAddedVariantId(0);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <Controller
          name="users"
          control={control}
          render={({field, fieldState}) => (
            <>
              <FileUpload
                label="Upload User Data"
                onChange={(file: File | null) => field.onChange(file)}
                error={errors.users?.message}
                userVehicleFileUrl={userVehicleFileUrl.userData}
              />
              {fieldState.error && (
                <p className="mt-1 text-xs text-red-500">
                  {fieldState.error.message}
                </p>
              )}
            </>
          )}
        />
        <Controller
          name="vehicles"
          control={control}
          render={({field, fieldState}) => (
            <>
              <FileUpload
                label="Upload Vehicle Data"
                onChange={(file: File | null) => field.onChange(file)}
                error={errors.vehicles?.message}
                userVehicleFileUrl={userVehicleFileUrl.vehicleData}
              />
              {fieldState.error && (
                <p className="mt-1 text-xs text-red-500">
                  {fieldState.error.message}
                </p>
              )}
            </>
          )}
        />
        <Controller
          name="tripType"
          control={control}
          render={({field}) => {
            const selectedKey =
              field.value !== null && field.value !== undefined
                ? String(field.value)
                : null;

            return (
              <NeoSelect
                label="Trip Type"
                placeholder="Please select trip type"
                color={errors.tripType ? "danger" : "default"}
                isInvalid={!!errors.tripType}
                errorMessage={errors.tripType?.message}
                selectedKeys={selectedKey ? [selectedKey] : []}
                onSelectionChange={keys => {
                  const key = Array.from(keys)[0];
                  field.onChange(Number(key));
                }}
                //onBlur={field.onBlur}
              >
                {[
                  {id: 0, label: "Pickup"},
                  {id: 1, label: "Drop"}
                ].map(item => (
                  <SelectItem key={item.id} value={String(item.id)}>
                    {item.label}
                  </SelectItem>
                ))}
              </NeoSelect>
            );
          }}
        />

        {/* <NeoSelect {...register("tripType")} label="Trip Type" size={"sm"}>
          {[
            {id: 0, label: "Pickup"},
            {id: 1, label: "Drop"}
          ]?.map(item => (
            <SelectItem key={item.id} value={item.id}>
              {item.label}
            </SelectItem>
          ))}
        </NeoSelect> */}
        <div className="flex justify-between gap-2">
          <>
            <Controller
              name="maxTravelDistance"
              control={control}
              render={({field}) => {
                const inputValue =
                  field.value != null ? String(field.value) : "";
                return (
                  <NeoTextBox
                    label="Max Distance(KM)"
                    placeholder="Max KM"
                    size="sm"
                    value={inputValue}
                    {...register("maxTravelDistance")}
                    color={errors.maxTravelDistance ? "danger" : "default"}
                    isInvalid={!!errors.maxTravelDistance}
                    errorMessage={errors.maxTravelDistance?.message}
                    endContent={
                      <Tooltip
                        content="The maximum distance this trip/route is allowed to travel, in kilometers."
                        color="primary"
                        showArrow={true}
                        placement="top"
                      >
                        <IoMdInformationCircleOutline className="h-4 w-4 cursor-pointer text-gray-500" />
                      </Tooltip>
                    }
                  />
                );
              }}
            />
          </>

          <Controller
            name="maxTravelTime"
            control={control}
            render={({field}) => {
              const inputValue = field.value != null ? String(field.value) : "";
              return (
                <NeoTextBox
                  label="Max Time(min)"
                  placeholder="Max Time"
                  size="sm"
                  value={inputValue}
                  {...register("maxTravelTime")}
                  color={errors.maxTravelTime ? "danger" : "default"}
                  isInvalid={!!errors.maxTravelTime}
                  errorMessage={errors.maxTravelTime?.message}
                  endContent={
                    <Tooltip
                      content="Maximum allowed travel time in minutes"
                      color="primary"
                      showArrow={true}
                      placement="top"
                    >
                      <IoMdInformationCircleOutline className="h-4 w-4 cursor-pointer text-gray-500" />
                    </Tooltip>
                  }
                />
              );
            }}
          />
        </div>

        <div className="flex justify-between gap-2">
          <Controller
            name="waitTime"
            control={control}
            render={({field}) => {
              const inputValue = field.value != null ? String(field.value) : "";
              return (
                <NeoTextBox
                  label="Wait Time(sec)"
                  placeholder="Wait Time"
                  size="sm"
                  value={inputValue}
                  {...register("waitTime")}
                  color={errors.waitTime ? "danger" : "default"}
                  isInvalid={!!errors.waitTime}
                  errorMessage={errors.waitTime?.message}
                  endContent={
                    <Tooltip
                      content="How many sec the vehicle should wait at a stop or pickup point."
                      color="primary"
                      showArrow={true}
                      placement="top"
                    >
                      <IoMdInformationCircleOutline className="h-4 w-4 cursor-pointer text-gray-500" />
                    </Tooltip>
                  }
                />
              );
            }}
          />
          {/* <Controller
            name="capacity"
            control={control}
            render={({field}) => {
              const inputValue = field.value != null ? String(field.value) : "";
              return (
                <NeoTextBox
                  {...field}
                  label="Capacity"
                  placeholder="Capacity"
                  size="sm"
                  id="capacity"
                  className="hidden"
                  value={inputValue}
                  {...register("capacity")}
                  color={errors.capacity ? "danger" : "default"}
                  isInvalid={!!errors.capacity}
                  errorMessage={errors.capacity?.message}
                  endContent={
                    <Tooltip
                      content="The maximum number of people/seats (or items) the vehicle can carry on this trip."
                      color="primary"
                      showArrow={true}
                      placement="top"
                    >
                        <IoMdInformationCircleOutline className="h-4 w-4 cursor-pointer text-gray-500" />
                    </Tooltip>
                  }
                />
              );
            }}
          /> */}
        </div>

        <div className="flex justify-between gap-2">
          <Controller
            name="startTime"
            control={control}
            rules={{required: "Start time is required"}}
            render={({field}) => (
              <TimeInput
                {...field}
                label="Start Time"
                //description="Please enter your meeting time"
                // onChange={value => field.onChange(value)} // update RHF
                // value={field.value ? parseTime(field.value) : undefined}
                value={field.value ? parseTime(field.value) : undefined}
                onChange={t => {
                  if (!t) return field.onChange("");
                  const hh = String(t.hour).padStart(2, "0");
                  const mm = String(t.minute).padStart(2, "0");
                  field.onChange(`${hh}:${mm}`);
                }}
                isInvalid={!!errors.startTime}
                color={errors.startTime ? "danger" : "default"}
                errorMessage={errors.startTime?.message}
                variant="bordered"
                labelPlacement="outside"
                size="sm"
                endContent={
                  <Tooltip
                    content="The earliest time this trip is allowed to start."
                    color="primary"
                    showArrow={true}
                    placement="top"
                  >
                    <FaRegClock className="h-3 w-3 cursor-pointer text-gray-500" />
                  </Tooltip>
                }

                // error={!!errors.startTime}
              />
            )}
          />

          <Controller
            name="endTime"
            control={control}
            rules={{required: "End time is required"}}
            render={({field}) => (
              <TimeInput
                {...field}
                label="End Time"
                //description="Please enter your meeting time"
                // onChange={value => field.onChange(value)} // update RHF
                // value={field.value ? parseTime(field.value) : undefined}
                value={field.value ? parseTime(field.value) : undefined}
                onChange={t => {
                  if (!t) return field.onChange("");
                  const hh = String(t.hour).padStart(2, "0");
                  const mm = String(t.minute).padStart(2, "0");
                  field.onChange(`${hh}:${mm}`);
                }}
                isInvalid={!!errors.endTime}
                color={errors.endTime ? "danger" : "default"}
                errorMessage={errors.endTime?.message}
                variant="bordered"
                labelPlacement="outside"
                size="sm"
                endContent={
                  <Tooltip
                    content="The latest time this trip must finish."
                    color="primary"
                    showArrow={true}
                    placement="top"
                  >
                    <FaRegClock className="h-3 w-3 cursor-pointer text-gray-500" />
                  </Tooltip>
                }

                // error={!!errors.startTime}
              />
            )}
          />
        </div>
        {/* {errorMessage ? <NeoError message={errorMessage}></NeoError> : null} */}
        <span className="text-center text-sm  text-gray-400">
          <div className="flex justify-center gap-2">
            {creditLoading && <Spinner color="primary" />}
            Credit Needed: {currentCreditPoint}
            <Tooltip
              content="The number of credits that will be used when you run or save this plan."
              color="primary"
              showArrow={true}
              placement="top"
            >
              <Image
                src={`/icons/routePlan/routePlancoin.svg`}
                alt={""}
                width={15}
                height={15}
              />
            </Tooltip>
          </div>
        </span>
        <NeoButton
          className="mx-5 mt-2"
          type="submit"
          size="sm"
          disabled={isSubmitting || currentCreditPoint === 0}
          isLoading={loading}
          spinner={
            <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
          }
          color="black"
          startContent={
            <>
              <svg
                width="11"
                height="15"
                viewBox="0 0 11 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.88379 9.08757C4.78648 9.3691 4.37425 9.3691 4.27694 9.08757L3.70636 7.43506C3.58076 7.0718 3.36916 6.74174 3.08832 6.47105C2.80748 6.20036 2.46512 5.99647 2.08838 5.87555L0.375742 5.32528C0.0838154 5.23144 0.0838155 4.83388 0.375742 4.74004L2.08926 4.18977C2.46594 4.06865 2.80818 3.86458 3.08887 3.59374C3.36956 3.3229 3.58097 2.99273 3.70636 2.6294L4.27694 0.97775C4.29792 0.916102 4.33855 0.862417 4.39304 0.824357C4.44753 0.786297 4.51309 0.765805 4.58037 0.765805C4.64764 0.765805 4.71321 0.786297 4.76769 0.824357C4.82218 0.862417 4.86281 0.916102 4.88379 0.97775L5.45437 2.63025C5.57988 2.99342 5.79135 3.32342 6.07203 3.59411C6.35271 3.8648 6.69489 4.06873 7.07147 4.18977L8.78499 4.74004C8.84891 4.76027 8.90458 4.79945 8.94404 4.852C8.98351 4.90455 9.00476 4.96777 9.00476 5.03266C9.00476 5.09754 8.98351 5.16077 8.94404 5.21332C8.90458 5.26586 8.84891 5.30505 8.78499 5.32528L7.07147 5.87555C6.69489 5.99658 6.35271 6.20052 6.07203 6.47121C5.79134 6.74189 5.57988 7.07189 5.45437 7.43506L4.88379 9.08757ZM8.3011 13.4377C8.28841 13.4746 8.26398 13.5068 8.23126 13.5295C8.19855 13.5523 8.15922 13.5646 8.11887 13.5646C8.07851 13.5646 8.03918 13.5523 8.00647 13.5295C7.97375 13.5068 7.94932 13.4746 7.93663 13.4377L7.59428 12.4463C7.44124 12.0044 7.08209 11.658 6.62385 11.5104L5.59591 11.1803C5.55761 11.1681 5.52427 11.1445 5.50064 11.1129C5.47701 11.0814 5.46429 11.0435 5.46429 11.0045C5.46429 10.9656 5.47701 10.9277 5.50064 10.8961C5.52427 10.8646 5.55761 10.841 5.59591 10.8288L6.62385 10.4986C6.84985 10.426 7.05521 10.3036 7.22365 10.1412C7.39209 9.97876 7.51899 9.78071 7.59428 9.56276L7.93663 8.57143C7.94932 8.53448 7.97375 8.50233 8.00647 8.47954C8.03918 8.45676 8.07851 8.44449 8.11887 8.44449C8.15922 8.44449 8.19855 8.45676 8.23126 8.47954C8.26398 8.50233 8.28841 8.53448 8.3011 8.57143L8.64345 9.56276C8.71875 9.78071 8.84564 9.97876 9.01408 10.1412C9.18253 10.3036 9.38788 10.426 9.61388 10.4986L10.6418 10.8288C10.6801 10.841 10.7135 10.8646 10.7371 10.8961C10.7607 10.9277 10.7734 10.9656 10.7734 11.0045C10.7734 11.0435 10.7607 11.0814 10.7371 11.1129C10.7135 11.1445 10.6801 11.1681 10.6418 11.1803L9.61388 11.5104C9.38788 11.5831 9.18253 11.7054 9.01408 11.8679C8.84564 12.0303 8.71874 12.2284 8.64345 12.4463L8.3011 13.4377ZM2.04768 14.3326C2.03895 14.3569 2.02259 14.3779 2.00087 14.3929C1.97915 14.4078 1.95315 14.4158 1.92649 14.4158C1.89983 14.4158 1.87383 14.4078 1.85211 14.3929C1.83039 14.3779 1.81403 14.3569 1.8053 14.3326L1.57706 13.6723C1.47533 13.3771 1.2356 13.1459 0.929518 13.0478L0.244818 12.8277C0.219629 12.8193 0.197786 12.8035 0.182328 12.7825C0.16687 12.7616 0.158565 12.7365 0.158565 12.7108C0.158565 12.6851 0.16687 12.66 0.182328 12.6391C0.197786 12.6181 0.219629 12.6023 0.244818 12.5939L0.929518 12.3738C1.08036 12.3254 1.21742 12.2438 1.32982 12.1354C1.44223 12.027 1.52688 11.8948 1.57706 11.7493L1.8053 11.089C1.81403 11.0647 1.83039 11.0436 1.85211 11.0287C1.87383 11.0138 1.89983 11.0058 1.92649 11.0058C1.95315 11.0058 1.97915 11.0138 2.00087 11.0287C2.02259 11.0436 2.03895 11.0647 2.04768 11.089L2.27592 11.7493C2.3261 11.8948 2.41075 12.027 2.52315 12.1354C2.63556 12.2438 2.77262 12.3254 2.92346 12.3738L3.60728 12.5939C3.63247 12.6023 3.65431 12.6181 3.66977 12.6391C3.68522 12.66 3.69353 12.6851 3.69353 12.7108C3.69353 12.7365 3.68522 12.7616 3.66977 12.7825C3.65431 12.8035 3.63247 12.8193 3.60728 12.8277L2.92258 13.0478C2.6165 13.1459 2.37676 13.3771 2.27503 13.6723L2.04768 14.3326Z"
                  fill="white"
                />
              </svg>
            </>
          }
        >
          Generate Optimized Route
        </NeoButton>
      </form>
      <NeoModal
        actionType={"routePlanProcessingPopup"}
        onOpen={processingPopupmodal}
        onClose={() => setProcessingPopupmodal(false)}
        hasActions={false}
        data={{changeVariant, newAddedVariantId, setIsHistoryTab}}
      ></NeoModal>
      <NeoModal
        actionType={"routeOptimizerInputError"}
        onOpen={processingErrorPopupmodal}
        onClose={() => setProcessingErrorPopupmodal(false)}
        hasActions={false}
        data={{errorMessage: inputParamsErrorMessage}}
      ></NeoModal>
    </>
  );
};
